<div class="dialog-container-style">
	<div class="dialog-header">
		<img src="../../../../assets/image/request-status-icon.png" />
		<div>{{ header | translate }}</div>
	</div>

	<div
		class="dialog-body"
		[ngClass]="{
			'text-center': data.type === 'Dup_Quote',
			'text-start': data.type === 'Dup_Active_Link'
		}"
	>
		<div [innerHTML]="description"></div>

		<div *ngIf="data.type === 'Dup_Quote'">
			{{ "dialog.duplicateDesc" | translate }}
		</div>
	</div>

	<div class="dialog-footer">
		<button (click)="onClose()">
			{{ "dialog.close" | translate }}
		</button>
	</div>
</div>
